<template>
  <m-category-card :category="item"/>
</template>

<script>
import mCategoryCard from "../../../../Category/Card/CategoryCard1";

export default {
  name: "SearchCategoryCard",
  props: ['item'],
  components: {mCategoryCard},
}
</script>

<style scoped>

</style>